import React from "react";
import Button from "./Button";
import "./CTASection.css";

const CTASection: React.FC = () => {
  return (
    <section className="cta" id="contact-section">
      <div className="cta-container">
        <div className="cta-content">
          <h2 className="cta-title">Ready to step into the 21st century?</h2>
          <p className="cta-description">
            Request early access to streamlined payments and
            stronger cash flow with Pagarva
          </p>
          <Button
            variant="primary"
            className="cta-button"
            href="/download/"
            trackingLabel="Download Today"
            trackingLocation="cta"
          >
            Download Today
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
